import React, { useEffect, useState, useCallback, Suspense } from 'react';
import LoaderComponent from '@components/atom/layout/loader';
import { useSelector } from 'react-redux';
import { RootState } from '@reducers/index';
import { QueryHookParam, useQueryDummyHook } from '@utils/hook/useQueryHook';

const AppInfo = React.lazy(() => import('@components/template/layout/appInfo/appInfo'));
const ScoreInfo = React.lazy(() => import('@components/template/aso/scoreInfo'));
const RsoCardType1 = React.lazy(() => import('@components/template/aso/rso/rsoCardType1'));
const RsoCardType2 = React.lazy(() => import('@components/template/aso/rso/rsoCardType2'));

const Rso = () => {
  const { selectedAppInfo } = useSelector((state: RootState) => state.LAYOUT);

  // cro 데이터
  const rsoParams: QueryHookParam = {
    key: ['rsoData', selectedAppInfo?.appId, selectedAppInfo?.provider_type],
    url: '/api/aso/rsoApple.json', // 여기서 강제로 바꿔줘야함... rsoGoogle.json / rsoApple.json
    params: { appId: selectedAppInfo?.appId, type: selectedAppInfo?.provider_type },
    method: 'GET',
    enabled: selectedAppInfo !== null,
  };
  const { data: rsoData, isLoading } = useQueryDummyHook(rsoParams);

  const titleObj = {
    title: 'RSO',
    subTitle: 'Conversation Rate, Optimization',
  };

  return (
    <>
      <div className="app-info">
        <Suspense fallback={<LoaderComponent />}>
          <AppInfo />
        </Suspense>
      </div>
      {rsoData && (
        <>
          <Suspense fallback={<LoaderComponent />}>
            <ScoreInfo titleObj={titleObj} data={rsoData} isLoading={isLoading} />
          </Suspense>
          <Suspense fallback={<LoaderComponent />}>
            <RsoCardType1 averageRating={rsoData?.averageRating} isLoading={isLoading} />
          </Suspense>
          <Suspense fallback={<LoaderComponent />}>
            <RsoCardType2 ratingNumber={rsoData?.ratingNumber} isloading={isLoading} />
          </Suspense>
        </>
      )}
    </>
  );
};

export default Rso;
